// extracted by mini-css-extract-plugin
module.exports = {"ExperienceFooter":"ln_a pz_a pz_ik pz_nz pz_r","ExperienceFooter__likesCount":"ln_b pz_a pz_j pz_ei"};